import { Injectable, ApplicationRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PopupList } from '../classes/popup-list';
import { MyStuffService } from './my-stuff.service';

@Injectable()
export class PopupService {
  popupList = new PopupList();
  activeRoute: string;

  constructor(public router: Router, public appRef: ApplicationRef) {}

  togglePopup(popup?, inner?, subInner?) {
    let w = (<any>window);
    this.closeAllPopups();
    if(popup) {
      this.popupList.popups[popup] = true;
      if(inner) {
        this.setInnerSection(popup, inner);
        if(subInner) {
          this.setSubInnerSection(inner, subInner);
        }
      }
    }
    w.Events.publish('detectChanges');
  }

  updateRoute(popup?, inner?, subInner?) {   
    if(popup) {
      inner = (inner)? inner :this.getInnerSection(popup);
      if(inner) {
        subInner =(subInner)? subInner :this.getSubInnerSection(inner);
      }
    }
    
    this.router.navigate([this.getActiveRoute()+((popup)?(popup+((inner)? ('/'+inner+((subInner)? ('/'+subInner):'')):'')):'')],{
      queryParamsHandling: 'merge',
      replaceUrl: true
    });    
  }

  closeAllPopups() {
    Object.keys(this.popupList.popups).map((popup)=>{
      if(this.popupList.popups[popup]) {
        this.popupList.popups[popup] = false;
      }
    });
  }

  getInnerSection(popup) {
    let innerPopup;
    switch(popup) {
      case 'share-map':
        return Object.keys(this.popupList.shareMapInner).find((inner) =>{
          return this.popupList.shareMapInner[inner] === true;
        });

      case 'my-stuff':
        return Object.keys(this.popupList.myStuffInner).find((inner) =>{
          return this.popupList.myStuffInner[inner] === true;
        });

      case 'log-in':
        innerPopup = Object.keys(this.popupList.signUpLogInInner).find((inner) =>{
          return this.popupList.signUpLogInInner[inner] === true;
        });
        this.popupList.signUpLogInInner[innerPopup] = false;

      case 'sign-up':
        innerPopup = Object.keys(this.popupList.signUpLogInInner).find((inner) =>{
          return this.popupList.signUpLogInInner[inner] === true;
        });
        this.popupList.signUpLogInInner[innerPopup] = false;

      case 'terms-conditions':
        innerPopup = Object.keys(this.popupList.signUpLogInInner).find((inner) => {
          return this.popupList.signUpLogInInner[inner] = true;
        });
        return this.popupList.signUpLogInInner[innerPopup]  = false;

      default:
        return null;
    }
  }

  getSubInnerSection(inner) {
    switch(inner) {
      case 'maps':
        return Object.keys(this.popupList.mapsSubInner).find((subInner) =>{
          return this.popupList.mapsSubInner[subInner] === true;
        });
      case 'removed':
        return Object.keys(this.popupList.removedSubInner).find((subInner) =>{
          return this.popupList.removedSubInner[subInner] === true;
        });
      default:
        return null;
    }
  }

  setInnerSection(popup, inner) {
    switch(popup) {
      case 'share-map':
        Object.keys(this.popupList.shareMapInner).forEach((obj)=>{
          this.popupList.shareMapInner[obj] = (obj === inner);
        });
        break;

      case 'my-stuff':
       Object.keys(this.popupList.myStuffInner).forEach((obj)=>{
          this.popupList.myStuffInner[obj] = (obj === inner);
        });
        break;

      case 'log-in':
       Object.keys(this.popupList.signUpLogInInner).forEach((obj)=>{
          this.popupList.signUpLogInInner[obj] = (obj === inner);
        });
        break;

      case 'sign-up':
       Object.keys(this.popupList.signUpLogInInner).forEach((obj)=>{
          this.popupList.signUpLogInInner[obj] = (obj === inner);
        });
        break;
    }
  }

  setSubInnerSection(inner, subInner) {
    switch(inner) {
      case 'maps':
        Object.keys(this.popupList.mapsSubInner).forEach((obj)=>{
          this.popupList.mapsSubInner[obj] = (obj === subInner);
        });
        break;
      case 'removed':
        Object.keys(this.popupList.removedSubInner).forEach((obj)=>{
          this.popupList.removedSubInner[obj] = (obj === subInner);
        });
        break;
    }
  }

  getActiveRoute() {
    this.router.isActive('/', false) && (this.activeRoute = '/map/');
    this.router.isActive('/map', false) && (this.activeRoute = '/map/');
    return this.activeRoute;
  }

  getActiveMyStuffPopup() {
    let activeMyStuffSection = {
      inner: null,
      subInner: null
    };
    activeMyStuffSection.inner = Object.keys(this.popupList.myStuffInner).find((inner) =>{
      return this.popupList.myStuffInner[inner] === true;
    }); 
    
    if(activeMyStuffSection.inner === 'maps') {
      activeMyStuffSection.subInner = Object.keys(this.popupList.mapsSubInner).find((subInner) =>{
        return this.popupList.mapsSubInner[subInner] === true;
      });
    } else if(activeMyStuffSection.inner === 'removed') {
      activeMyStuffSection.subInner = Object.keys(this.popupList.removedSubInner).find((subInner) =>{
        return this.popupList.removedSubInner[subInner] === true;
      });
    } 
    return activeMyStuffSection;  
  }
}



// WEBPACK FOOTER //
// ./src/app/services/popup.service.ts